// Soorten huishouden en het beurtrooster (golf 6b, 0043_huishoudtypes). Handgeschreven zoals
// push.ts en gelijk aan de API (apps/api/src/routes/v1/app/householdType.ts en rotation.ts);
// openapi.contract.test.ts bewaakt elke aanroep.
const id = (value) => encodeURIComponent(value);
function query(params) {
    const parts = Object.entries(params)
        .filter((e) => e[1] !== undefined)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
    return parts.length > 0 ? `?${parts.join('&')}` : '';
}
export function createHouseholdsClient(t) {
    const get = (path) => t.request('GET', path);
    const post = (path, body = {}) => t.request('POST', path, body);
    const put = (path, body) => t.request('PUT', path, body);
    const del = (path) => t.request('DELETE', path);
    return {
        type: {
            get: () => get('/v1/app/household/type'),
            /** Golf 8: met de antwoorden over het huis klopt "Dit zetten we aan". */
            preview: (type, resetChoices = false, house) => {
                const reset = resetChoices ? 'true' : undefined;
                return get(`/v1/app/household/type/preview${query({
                    type,
                    reset_choices: reset,
                    residents: house ? String(house.residents) : undefined,
                    shares: house && house.shares.length > 0 ? house.shares.join(',') : undefined,
                })}`);
            },
            set: (input) => put('/v1/app/household/type', input),
        },
        rotation: {
            overview: () => get('/v1/app/rotation'),
            setup: (duties) => post('/v1/app/rotation/setup', { duties }),
            setDuty: (itemId, cadence, ifVersion) => put(`/v1/app/rotation/duties/${id(itemId)}`, {
                cadence,
                if_version: ifVersion,
            }),
            swap: (input) => post('/v1/app/rotation/swaps', input),
            removeSwap: (itemId, periodStart) => del(`/v1/app/rotation/swaps/${id(itemId)}/${id(periodStart)}`),
            addAway: (input) => post('/v1/app/rotation/away', input),
            removeAway: (awayId) => del(`/v1/app/rotation/away/${id(awayId)}`),
        },
    };
}
//# sourceMappingURL=households.js.map